import { ref, readonly, useContext } from "@nuxtjs/composition-api";
import { Logger } from "@wemade-vsf/core";
import { loadPageCommand } from "./commands/loadPageCommand";
import { loadBlocksCommand } from "./commands/loadBlocksCommand";
function useCmsContent() {
  const loading = ref(false);
  const error = ref({
    page: null,
    blocks: null
  });
  const { app } = useContext();
  const context = app.$vsf;
  async function loadPage(params) {
    Logger.debug("useCmsContent/loadPage");
    loading.value = true;
    let result = null;
    try {
      error.value.page = null;
      result = loadPageCommand.execute(context, params);
    } catch (err) {
      error.value.page = err;
    } finally {
      loading.value = false;
    }
    return result;
  }
  async function loadBlocks(params) {
    Logger.debug("useCmsContent/loadBlocks");
    loading.value = true;
    let result = null;
    try {
      error.value.blocks = null;
      result = loadBlocksCommand.execute(context, params);
    } catch (err) {
      error.value.blocks = err;
    } finally {
      loading.value = false;
    }
    return result;
  }
  return {
    loading: readonly(loading),
    error: readonly(error),
    loadPage,
    loadBlocks
  };
}
export {
  useCmsContent
};
